export default __webpack_public_path__ + "static/main_mobile-poster-f457c1636dec9bbf4457b2d4b6d65a2b.avif";